import Container from './BatchActionLayout.container';
import BatchActionLayout from './BatchActionLayout';

export default Container(BatchActionLayout);
